import React, { Fragment } from "react"

const portionTitles = {
  fa: { firstHalf: "نیمه اول", secondHalf: "نیمه دوم" },
  en: { firstHalf: "First half", secondHalf: "Second half" },
  ar: { firstHalf: "النصف الأول", secondHalf: "النصف الثاني" },
  tr: { firstHalf: "İlk yarı", secondHalf: "İkinci yarı" }
}

const nameLanguages = { name: "fa", nameEn: "en", nameAr: "ar" }

const withoutPortionPrefix = item => {
  const result = { ...item }

  // Order print data (including saved failed prints) already prefixes each name.
  // The section heading now supplies that label; cart items have plain names.
  Object.keys(nameLanguages).forEach(field => {
    const title = portionTitles[nameLanguages[field]][item.portion]
    const prefix = `${title}: `

    if (title && typeof result[field] === "string" && result[field].startsWith(prefix)) {
      result[field] = result[field].slice(prefix.length)
    }
  })

  return result
}

const PlSpecificationItems = ({ items = [], language = "fa", children }) => {
  const wholeItems = items.filter(item =>
    item.portion !== "firstHalf" && item.portion !== "secondHalf"
  )
  const titles = portionTitles[language] || portionTitles.fa

  return (
    <Fragment>
      {wholeItems.map(children)}
      {["firstHalf", "secondHalf"].map(portion => {
        const portionItems = items.filter(item => item.portion === portion)

        if (portionItems.length === 0) return null

        return (
          <section key={portion} aria-label={titles[portion]} style={styles.portion}>
            <div style={styles.title}>{titles[portion]}</div>
            {portionItems.map((item, index) => children(withoutPortionPrefix(item), index))}
          </section>
        )
      })}
    </Fragment>
  )
}

const styles = {
  portion: {
    alignSelf: "stretch",
    minWidth: 0,
    marginTop: "0.4em",
    paddingTop: "0.2em",
    borderTop: "1px solid currentColor",
    breakInside: "avoid",
    pageBreakInside: "avoid"
  },
  title: {
    fontWeight: "bold",
    marginBottom: "0.15em"
  }
}

export default PlSpecificationItems
